import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { WsSelectObj } from 'wisestep-base';

const useCandidateStatusesByStage = (stageStatusPipeline: string, stage: string) => {
  const [statuses, setStatuses] = useState<WsSelectObj[]>([]);

  useEffect(() => {
    const getCandidateSettings = async () => {
      !isEmpty(stageStatusPipeline) &&
        JSON.parse(stageStatusPipeline).filter(
          (object) =>
            object.stage === stage &&
            setStatuses(object.statuses.filter((status) => status.status === 'active'))
        );
    };
    getCandidateSettings();
  }, [stage, stageStatusPipeline]);

  return statuses;
};

export default useCandidateStatusesByStage;
